export const SUPPORTED_REGIONS = ['eu-west-1', 'us-east-1'] as const;

export type SupportedRegion = (typeof SUPPORTED_REGIONS)[number];

export const DEFAULT_REGION: SupportedRegion = 'eu-west-1';

export const isSupportedRegion = (value: string | undefined): value is SupportedRegion =>
  !!value && (SUPPORTED_REGIONS as readonly string[]).includes(value);
